// 3_pages/acount_pages.js
// Customer account pages: strips the leading "Moje " from sidebar links (except a
// few excluded ones) and wraps every table in a scroll wrapper.

export function init() {
	if (!document.body.classList.contains("customer-page")) return;

	removeMojeFromSidebar();
	wrapAnyTable();
}

function removeMojeFromSidebar() {
	const sidebar = document.querySelector(".sidebar");
	if (!sidebar) return;

	const links = sidebar.querySelectorAll("li a");
	const excludedTexts = ["Moje slevy", "Moje hodnocení u produktů", "Moje zlavy", "Moje recenzie u produktov"]; // Add any other texts you want to exclude here

	links.forEach((link) => {
		const text = link.textContent.trim();

		// Skip if it's one of the excluded texts
		if (excludedTexts.includes(text)) return;

		// Remove "Moje " from the beginning and trim
		if (text.startsWith("Moje ")) {
			let newText = text.replace(/^Moje\s+/, "").trim();
			// Capitalize first letter
			newText = newText.charAt(0).toUpperCase() + newText.slice(1);
			link.textContent = newText;
		}
	});
}

function wrapAnyTable() {
	const tables = document.querySelectorAll("table");
	tables.forEach((table) => {
		const wrapper = document.createElement("div");
		wrapper.classList.add("table-wrapper");
		table.parentNode.insertBefore(wrapper, table);
		wrapper.appendChild(table);
	});
}
